import { DEVICE, Image } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
  text-transform: capitalize;
`;

const RecipientCharity = styled.div`
  display: flex;
  gap: 40px;
  line-height: 150%;
`;

const RecipientCharityImage = styled.div`
  height: fit-content;
  position: relative;
`;

const RecipientCharityBody = styled.div``;

const RecipientCharityDescription = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  display: -webkit-box;
  overflow: hidden;
`;

const IconWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 2px solid var(--color-bg-weaker2);
  border-radius: var(--border-full);
  bottom: -4px;
  display: flex;
  height: 30px;
  justify-content: center;
  position: absolute;
  right: -4px;
  width: 30px;
`;

const TableHeaderButtonWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const RecipientDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ProductDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 200px;
`;

const SelectedItem = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  ${Image?.S?.Image} {
    border-radius: var(--radius-m);
  }
  ${({ isNonEmpty }) =>
    isNonEmpty &&
    css`
      align-items: flex-start;
      gap: 16px;
      justify-content: flex-start;
    `}
`;

const PaperWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const GiftStatus = styled.div`
  flex: 1;
  margin-top: 12px;
`;

const GiftStatusGroup = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const Timeline = styled.div`
  background-color: var(--color-bg-weaker);
  padding: 24px 0;
  width: 162px;
`;

const Steps = styled.div`
  position: relative;

  ${DEVICE.mobile.max} {
    &::after {
      left: 32px;
    }
  }
`;

const Dot = styled.div`
  border-radius: 100%;
  position: relative;
  z-index: 3;

  &::after {
    background-color: var(--color-bg-strong2);
    border-radius: var(--radius-full);
    content: ' ';
    height: 8px;
    left: 30px;
    position: absolute;
    transform: translate(-50%, 60%);
    width: 8px;

    ${({ isSelected }) =>
      isSelected &&
      css`
        background-color: var(--color-bg-weaker);
        border: 3px solid var(--color-bg-strong2);
        height: 14px;
        width: 14px;
      `}
  }
`;

const StepContent = styled.div`
  margin-left: 47px;
  position: relative;
`;

const StepsContainer = styled.div`
  background-color: inherit;
  display: flex;
  margin-top: 60px;

  &:first-child {
    margin-top: 0;
  }

  &:not(:last-child) {
    ${StepContent} {
      &::after {
        border-color: var(--color-border-strong);
        border-right: 1px dashed var(--color-border-strong);
        bottom: -50px;
        content: '';
        left: -18px;
        position: absolute;
        top: 30px;
      }
    }
  }

  ${DEVICE.mobile.max} {
    flex-direction: row-reverse;
    left: 0;
    margin-bottom: 16px;
    width: auto;
  }
`;

const StepDate = styled.div`
  display: flex;
  margin-top: 8px;

  &:before {
    background-color: var(--color-bg-strong2);
    border-radius: 0 var(--radius-m) var(--radius-m) 0;
    content: '';
    height: 1px;
    margin-left: -17px;
    margin-top: 9px;
    position: absolute;
    width: 9px;
  }
`;

const ProductDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export {
  CardHeader,
  Dot,
  GiftStatus,
  GiftStatusGroup,
  IconWrapper,
  PaperWrapper,
  ProductDetail,
  ProductDetailHeader,
  RecipientCharity,
  RecipientCharityBody,
  RecipientCharityDescription,
  RecipientCharityImage,
  RecipientDetailWrapper,
  SelectedItem,
  StepContent,
  StepDate,
  Steps,
  StepsContainer,
  TableHeaderButtonWrapper,
  Timeline
};
